// extracted by mini-css-extract-plugin
module.exports = {"right":"Header_right__2N1fC","select":"Header_select__1yyph","clinic":"Header_clinic__2zZlL"};